const isRightVersion = (browserVer,configVer) => {
    const browserVerArr = browserVer.split('.');
    const configVerArr = configVer.split('.');
    const configVerArrLen = configVerArr.length;
    for(let i=0 ; i<configVerArrLen ; i++){
      // console.log(configVerArr[i], browserVerArr[i])

        if(+configVerArr[i] < +browserVerArr[i]){
            return true;
        }
    // else {
    //       return false
    //     }
    }

  return false
    // return true;
}

// console.log(isRightVersion('85.0.4183.121', '85.0.4200'))
// console.log(isRightVersion('13', '12.0'))

export default isRightVersion
